import * as helper from "../../common/utils/helper"
import * as aes from "../../common/utils/aes"
import * as request from "../../common/utils/request"

export function taskProc(params, extendParams) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    let data = {
      from_https: 1,
      from_h5: 1,
      pf: "mds_wechat_gmshop-pay_html5-html5",
      pfkey: "pfkey",
      accounttype: "qb",
      t: +new Date()
    }
    data = Object.assign(data, extendParams, aes.encrypt(extendParams, ["openid", "openkey", "session_id", "session_type"], params.sandbox))

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/task_proc`,
        data: data
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}
